const paths: string[] = [
    require('./everyday_digital_and_weekend_papers_cropped.png'),
    require('./everyday_digital_and_weekend_papers.png'),
    require('./everyday_digital_cropped.png'),
    require('./everyday_digital.png'),
    require('./mon-sat_and_everyday_digital_cropped.png'),
    require('./mon-sat_and_everyday_digital.png'),
    require('./mon-sun_and_everyday_digital_cropped.png'),
    require('./mon-sun_and_everyday_digital.png'),
    require('./sunday_times_cropped.png'),
    require('./sunday_times.png'),
    require('./twa_sat_cropped.png'),
    require('./twa_sat.png'),
    require('./weekend_cropped.png'),
    require('./weekend.png'),
]

const mobilePaths: string[] = [
    require('./mobile/everyday_digital_and_weekend_papers_cropped.png'),
    require('./mobile/everyday_digital_and_weekend_papers.png'),
    require('./mobile/everyday_digital_cropped.png'),
    require('./mobile/everyday_digital.png'),
    require('./mobile/mon-sat_and_everyday_digital_cropped.png'),
    require('./mobile/mon-sat_and_everyday_digital.png'),
    require('./mobile/mon-sun_and_everyday_digital_cropped.png'),
    require('./mobile/mon-sun_and_everyday_digital.png'),
    require('./mobile/sunday_times_cropped.png'),
    require('./mobile/sunday_times.png'),
    require('./mobile/twa_sat_cropped.png'),
    require('./mobile/twa_sat.png'),
    require('./mobile/weekend_cropped.png'),
    require('./mobile/weekend.png'),
]

export const packageImages: { [imageName: string]: string } = {}
for (let i = 0; i < paths.length; i++) {
    const path = paths[i]
    const fileName = path
        .substring(path.lastIndexOf('/') + 1)
        .replace(/\..*\.png/, '.png')
    packageImages[fileName] = path
    const mobilePath = mobilePaths[i]
    packageImages['mobile/' + fileName] = mobilePath
}
